/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Property orientation.
 */
export enum PropertyOrientation {
    N = 'N',
    S = 'S',
    E = 'E',
    W = 'W',
    NE = 'NE',
    NW = 'NW',
    SE = 'SE',
    SW = 'SW',
}
